export default "__VITE_ASSET__e27db394__"